import { render, staticRenderFns } from "./AssignDetailView.vue?vue&type=template&id=1816a9ef"
import script from "./AssignDetailView.vue?vue&type=script&lang=js"
export * from "./AssignDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports